import { render } from "./ElementBox.vue?vue&type=template&id=1be35e66&scoped=true"
import script from "./ElementBox.vue?vue&type=script&lang=js"
export * from "./ElementBox.vue?vue&type=script&lang=js"

import "./ElementBox.vue?vue&type=style&index=0&id=1be35e66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be35e66"]])

export default __exports__